"use strict";

exports.__esModule = true;
exports.getRegionlessLanguage = getRegionlessLanguage;

function getRegionlessLanguage(language) {
  return language.split('-')[0];
}